<!-- color-palette.component.html -->
<div class="d-flex conatiner-gap align-items-center">
    <div class="row">
        <!-- Light Mode -->
        <div class="col-6 pointer">
            <div class="text-center mb-2" [ngClass]="selectedValues.mode=='light' ? 'selected-mode' : ''">
                {{"Light Mode"|translate}}
            </div>
            <div (click)="modeSelected('light')">
                <ng-container *ngIf="previewImages.light; else lightBg">
                    <img [src]="previewImages.light" class="mode img-fluid" alt="Light Preview">
                </ng-container>
                <ng-template #lightBg>
                    <div class="mode" [style]="{'background': selectedValues.gridModeColor.light}"></div>
                </ng-template>
            </div>
            <div class="d-flex justify-content-center">
                <mat-icon (click)="copyDrawnPixels('light','dark')"
                    class="position-absolute pixel-tool-icon me-2 copy-icon"
                    [matTooltip]="'Copy icon from light mode to dark mode.' | translate"
                    [class.disabled]="!getIconCreationStatus().light">
                    east
                </mat-icon>
            </div>
        </div>

        <!-- Dark Mode -->
        <div class="col-6 pointer">
            <div class="text-center mb-2" [ngClass]="selectedValues.mode=='dark' ? 'selected-mode' : ''">
                {{"Dark Mode"|translate}}
            </div>
            <div (click)="modeSelected('dark')">
                <ng-container *ngIf="previewImages.dark; else darkBg">
                    <img [src]="previewImages.dark" class="mode img-fluid" alt="Dark Preview">
                </ng-container>
                <ng-template #darkBg>
                    <div class="mode" [style]="{'background': selectedValues.gridModeColor.dark}"></div>
                </ng-template>
            </div>
            <div class="d-flex justify-content-center">
                <mat-icon (click)="copyDrawnPixels('dark','light')"
                    class="position-absolute pixel-tool-icon me-2 copy-icon"
                    [matTooltip]="'Copy icon from dark mode to light mode.' | translate"
                    [class.disabled]="!getIconCreationStatus().dark">
                    west
                </mat-icon>
            </div>
        </div>
    </div>

    <div class="d-flex flex-column">
        <div class="d-flex justify-content-between mb-1 gap">
            <h3 class="lms-card-heading module-heading-success">{{'Pixel Editor'|translate}}</h3>
            <div>
                <input type="color" [(ngModel)]="selectedValues.drawColor" name="colorInput"
                    class="pixel-tool-icon me-2" [matTooltip]="'Select Color'|translate" />
                <mat-icon (click)="reset()" class="pixel-tool-icon me-2"
                    [matTooltip]="'Reset'|translate">refresh</mat-icon>
                <mat-icon (click)="toggleCleaning()" class="pixel-tool-icon me-2"
                    [matTooltip]="selectedValues.isCleaning ? ('Enable Drawing'|translate): ('Clean'|translate)">
                    {{ selectedValues.isCleaning ? 'edit' : 'cleaning_services'}}
                </mat-icon>
                <!-- <mat-icon class="pixel-tool-icon me-2" title="Preview" (click)="togglePreview()">visibility</mat-icon> -->
                <!-- <mat-icon class="pixel-tool-icon" title="Save" (click)="uploadGeneratedImage()">save</mat-icon> -->
                <!-- <mat-icon class="pixel-tool-icon" title="Save" (click)="downloadImage()">download</mat-icon> -->
            </div>
        </div>
        <div class="grid">
            <div *ngFor="let pixel of pixels; let i = index" [style.background-color]="pixel"
                (mousedown)="paintPixel(i)" (mouseover)="selectedValues.draw && paintPixel(i)">
            </div>
        </div>
    </div>
    <!-- <div class="d-flex flex-column theme-container">
        <h5 class="text-dark">Theme Colors</h5>
        <div class="d-flex flex-row mb-4 gap">
            <div *ngFor="let color of colorPallete.primary" class="color-box" [style.backgroundColor]="color"
                [title]="color" (click)="colorSelected(color)"
                [ngClass]="selectedValues.drawColor==color?'selected-color':''">
            </div>
        </div>
        <div class="d-flex flex-row gap">
            <div *ngFor="let column of colorPallete.variants" class="d-flex flex-column">
                <div *ngFor="let color of column" class="color-box" [style.backgroundColor]="color" [title]="color"
                    (click)="colorSelected(color)" [ngClass]="selectedValues.drawColor==color?'selected-color':''">
                </div>
            </div>
        </div>
    </div> -->
</div>